/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, QueryClient, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import type {
	AccessTokenResponseDto,
	MessageResponseDto,
	SendVerificationDto,
	VerifyCodeDto,
	VerifyCodeResponseDto,
} from '../model';

import { axiosInstance } from '../../axiosInstance';

/**
 * httpOnly 쿠키의 Refresh Token으로 새로운 Access Token을 발급 (사용자/관리자 공통)
 * @summary 토큰 갱신
 */
export const authControllerRefreshTokenV1 = (signal?: AbortSignal) => {
	return axiosInstance<AccessTokenResponseDto>({ url: `/v1/auth/refresh`, method: 'POST', signal });
};

export const getAuthControllerRefreshTokenV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshTokenV1>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshTokenV1>>, TError, void, TContext> => {
	const mutationKey = ['authControllerRefreshTokenV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRefreshTokenV1>>, void> = () => {
		return authControllerRefreshTokenV1();
	};

	return { mutationFn, ...mutationOptions };
};

export type AuthControllerRefreshTokenV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof authControllerRefreshTokenV1>>
>;

export type AuthControllerRefreshTokenV1MutationError = void;

/**
 * @summary 토큰 갱신
 */
export const useAuthControllerRefreshTokenV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshTokenV1>>, TError, void, TContext>;
	},
	queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof authControllerRefreshTokenV1>>, TError, void, TContext> => {
	return useMutation(getAuthControllerRefreshTokenV1MutationOptions(options), queryClient);
};
/**
 * Redis 세션 및 Refresh Token 쿠키를 삭제 (사용자/관리자 공통)
 * @summary 로그아웃
 */
export const authControllerLogoutV1 = (signal?: AbortSignal) => {
	return axiosInstance<MessageResponseDto>({ url: `/v1/auth/logout`, method: 'POST', signal });
};

export const getAuthControllerLogoutV1MutationOptions = <TError = unknown, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerLogoutV1>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof authControllerLogoutV1>>, TError, void, TContext> => {
	const mutationKey = ['authControllerLogoutV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerLogoutV1>>, void> = () => {
		return authControllerLogoutV1();
	};

	return { mutationFn, ...mutationOptions };
};

export type AuthControllerLogoutV1MutationResult = NonNullable<Awaited<ReturnType<typeof authControllerLogoutV1>>>;

export type AuthControllerLogoutV1MutationError = unknown;

/**
 * @summary 로그아웃
 */
export const useAuthControllerLogoutV1 = <TError = unknown, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerLogoutV1>>, TError, void, TContext>;
	},
	queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof authControllerLogoutV1>>, TError, void, TContext> => {
	return useMutation(getAuthControllerLogoutV1MutationOptions(options), queryClient);
};
/**
 * 휴대폰 또는 이메일로 인증번호 발송
 * @summary 인증번호 발송
 */
export const authControllerSendVerificationV1 = (sendVerificationDto: SendVerificationDto, signal?: AbortSignal) => {
	return axiosInstance<MessageResponseDto>({
		url: `/v1/auth/send-verification`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: sendVerificationDto,
		signal,
	});
};

export const getAuthControllerSendVerificationV1MutationOptions = <TError = unknown, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof authControllerSendVerificationV1>>,
		TError,
		{ data: SendVerificationDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof authControllerSendVerificationV1>>,
	TError,
	{ data: SendVerificationDto },
	TContext
> => {
	const mutationKey = ['authControllerSendVerificationV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof authControllerSendVerificationV1>>,
		{ data: SendVerificationDto }
	> = (props) => {
		const { data } = props ?? {};

		return authControllerSendVerificationV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AuthControllerSendVerificationV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof authControllerSendVerificationV1>>
>;
export type AuthControllerSendVerificationV1MutationBody = SendVerificationDto;
export type AuthControllerSendVerificationV1MutationError = unknown;

/**
 * @summary 인증번호 발송
 */
export const useAuthControllerSendVerificationV1 = <TError = unknown, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof authControllerSendVerificationV1>>,
			TError,
			{ data: SendVerificationDto },
			TContext
		>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof authControllerSendVerificationV1>>,
	TError,
	{ data: SendVerificationDto },
	TContext
> => {
	return useMutation(getAuthControllerSendVerificationV1MutationOptions(options), queryClient);
};
/**
 * 발송된 인증번호 확인
 * @summary 인증번호 확인
 */
export const authControllerVerifyCodeV1 = (verifyCodeDto: VerifyCodeDto, signal?: AbortSignal) => {
	return axiosInstance<VerifyCodeResponseDto>({
		url: `/v1/auth/verify-code`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: verifyCodeDto,
		signal,
	});
};

export const getAuthControllerVerifyCodeV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof authControllerVerifyCodeV1>>,
		TError,
		{ data: VerifyCodeDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof authControllerVerifyCodeV1>>,
	TError,
	{ data: VerifyCodeDto },
	TContext
> => {
	const mutationKey = ['authControllerVerifyCodeV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof authControllerVerifyCodeV1>>,
		{ data: VerifyCodeDto }
	> = (props) => {
		const { data } = props ?? {};

		return authControllerVerifyCodeV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AuthControllerVerifyCodeV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof authControllerVerifyCodeV1>>
>;
export type AuthControllerVerifyCodeV1MutationBody = VerifyCodeDto;
export type AuthControllerVerifyCodeV1MutationError = void;

/**
 * @summary 인증번호 확인
 */
export const useAuthControllerVerifyCodeV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof authControllerVerifyCodeV1>>,
			TError,
			{ data: VerifyCodeDto },
			TContext
		>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof authControllerVerifyCodeV1>>,
	TError,
	{ data: VerifyCodeDto },
	TContext
> => {
	return useMutation(getAuthControllerVerifyCodeV1MutationOptions(options), queryClient);
};
